// Cotado × Realizado (PO1-3621): agrupamento dos meses da matriz em mês /
// trimestre / semestre / ano e soma das células. Funções puras, sem React,
// espelho de backend_hub/.../gobid-cotado-realizado/helpers/periodosAgrupados.js.
// Testado em __tests__/periodos.test.js.

const REGEX_MES = /^(\d{4})-(\d{2})/;
const MESES_ABREV = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

export const VISOES = [
  { key: "mes", label: "Mês" },
  { key: "trimestre", label: "Trimestre" },
  { key: "semestre", label: "Semestre" },
  { key: "ano", label: "Ano" },
];

export const QUEBRAS = [
  { key: "total", label: "Total" },
  { key: "uf", label: "Região / UF" },
  { key: "transportadora", label: "Transportadora" },
];

function partes(mes) {
  const m = REGEX_MES.exec(String(mes || ""));
  if (!m) throw new Error(`Mês inválido: ${mes}`);
  return { ano: Number(m[1]), mes: Number(m[2]) };
}

export function mesesDoPeriodo(desde, ate) {
  const d = partes(desde);
  const a = partes(ate);
  const lista = [];
  let ano = d.ano;
  let mes = d.mes;
  while (ano < a.ano || (ano === a.ano && mes <= a.mes)) {
    lista.push(`${ano}-${String(mes).padStart(2, "0")}`);
    mes += 1;
    if (mes > 12) {
      mes = 1;
      ano += 1;
    }
  }
  return lista;
}

export function rotuloMes(mes) {
  const p = partes(mes);
  return `${MESES_ABREV[p.mes - 1]}/${String(p.ano).slice(2)}`;
}

export function chaveDoGrupo(mes, visao) {
  const p = partes(mes);
  if (visao === "mes") return mes;
  if (visao === "trimestre") return `${p.ano}-T${Math.ceil(p.mes / 3)}`;
  if (visao === "semestre") return `${p.ano}-S${p.mes <= 6 ? 1 : 2}`;
  if (visao === "ano") return String(p.ano);
  throw new Error(`Visão inválida: ${visao}`);
}

export function rotuloDoGrupo(chave, visao) {
  if (visao === "mes") return rotuloMes(chave);
  if (visao === "ano") return chave;
  const [ano, sufixo] = chave.split("-");
  return `${sufixo.slice(1)}º ${visao === "trimestre" ? "tri" : "sem"}/${String(ano).slice(2)}`;
}

// [{ chave, rotulo, visao, meses, completo }]
export function gruposDoPeriodo(meses, visao) {
  const porChave = new Map();
  (meses || []).forEach((mes) => {
    const chave = chaveDoGrupo(mes, visao);
    if (!porChave.has(chave)) porChave.set(chave, { chave, rotulo: rotuloDoGrupo(chave, visao), visao, meses: [] });
    porChave.get(chave).meses.push(mes);
  });
  const tamanho = { mes: 1, trimestre: 3, semestre: 6, ano: 12 }[visao];
  return [...porChave.values()].map((g) => ({ ...g, completo: g.meses.length === tamanho }));
}

// Soma métricas (números e objetos aninhados). null de um lado é ignorado.
export function somarMetricas(a, b) {
  if (a === null || a === undefined) return b === undefined ? null : b;
  if (b === null || b === undefined) return a;
  if (typeof a === "number" || typeof b === "number") return Number(a || 0) + Number(b || 0);
  const r = {};
  new Set(Object.keys(a).concat(Object.keys(b))).forEach((k) => {
    r[k] = somarMetricas(a[k], b[k]);
  });
  return r;
}

// Soma as células dos meses do grupo; null se nenhum mês tem dado ("—").
export function somarGrupo(celulas, mesesDoGrupo) {
  let total = null;
  (mesesDoGrupo || []).forEach((mes) => {
    const c = celulas ? celulas[mes] : null;
    if (c !== null && c !== undefined) total = somarMetricas(total, c);
  });
  return total;
}

// Variação percentual atual × anterior (1 casa); null sem base.
export function variacao(atual, anterior) {
  const a = Number(atual || 0);
  const b = Number(anterior || 0);
  if (!Number.isFinite(a) || !Number.isFinite(b) || b === 0) return null;
  return Math.round(((a - b) / Math.abs(b)) * 1000) / 10;
}
